import React from 'react';
import DefaultModal from './DefaultModal';
import { formatDateView } from '../../utils/dateUtils.jsx';

function ExtratoPicker({ show, onClose, extratos = [], programas = [], contas = [] }) {
  // Função utilitária para buscar descrição do programa pelo idPrograma
  const getProgramaDescricao = (idPrograma) => {
    const p = programas.find(p => String(p.id) === String(idPrograma));
    return p ? p.descricao : '-';
  };
  // Função utilitária para buscar descrição da conta pelo idConta
  const getContaDescricao = (idConta) => {
    const c = contas.find(c => String(c.numConta) === String(idConta) || String(c.id) === String(idConta));
    return c ? (c.descricao || c.numConta) : '-';
  };
  // Ordenar extratos por data (ascendente)
  const extratosOrdenados = [...extratos].sort((a, b) => {
    const dataA = new Date(a.data || a.dataMov || 0);
    const dataB = new Date(b.data || b.dataMov || 0);
    return dataA - dataB;
  });
  // Soma total dos valores
  const totalValores = extratosOrdenados.reduce((sum, e) => {
    const v = e.vlr != null ? Number(e.vlr) : (e.valor != null ? Number(e.valor) : 0);
    return sum + (isNaN(v) ? 0 : v);
  }, 0);
  return (
    <DefaultModal show={show} onClose={onClose} title="Extratos Bancários">
      <div style={{ maxHeight: 400, overflowY: 'auto' }}>
        <table className="table table-sm table-bordered">
          <thead>
            <tr>
              <th>#</th>
              <th>Data</th>
              <th>Programa</th>
              <th>Conta</th>
              <th>Valor</th>
            </tr>
          </thead>
          <tbody>
            {extratosOrdenados.length === 0 ? (
              <tr><td colSpan="5" className="text-center text-muted">Nenhum extrato encontrado.</td></tr>
            ) : (
              extratosOrdenados.map((e, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{formatDateView(e.data || e.dataMov || '') || '-'}</td>
                  <td>{getProgramaDescricao(e.idPrograma)}</td>
                  <td>{getContaDescricao(e.idConta)}</td>
                  <td className="text-end">{e.vlr != null ? Number(e.vlr).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : (e.valor != null ? Number(e.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '-')}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        <div className="d-flex justify-content-between align-items-center text-secondary small mt-2">
          <span>Total de registros: <b>{extratosOrdenados.length}</b></span>
          <span>Total dos valores: <b>{totalValores.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</b></span>
        </div>
      </div>
    </DefaultModal>
  );
}

export default ExtratoPicker;
